import React from 'react'
import styles from './OrderForm.module.css'
import TextArea from '../TextArea'

interface Props {
  localStoreComment?: string
  originalStoreComment?: string
  onStoreCommentChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void
  noBottomSpacing?: boolean
}

function StoreComment ({ localStoreComment, originalStoreComment, onStoreCommentChange, noBottomSpacing = false }: Props) {
  return (
    <div className={`${styles.commentSection} ${noBottomSpacing ? styles.noBottomSpacing : ''}`}>
      <h4 style={{ marginTop: '1rem' }} className={styles.heading}>
        {originalStoreComment ? 'Ändra intern butikskommentar' : 'Skriv en intern butikskommentar till ordern'}
      </h4>
      <span className={styles.sectionLabel}>Intern butikskommentar</span>
      <span className={styles.infoText}>Denna kommentar kommer enbart visas för er butiksmedarbetare och blir ej synlig ut mot kunden.</span>
      <TextArea
        placeholder={localStoreComment ? localStoreComment : 'Skriv en intern butikskommentar'} 
        value={localStoreComment as string} 
        setComment={(e: React.ChangeEvent<HTMLTextAreaElement>) => onStoreCommentChange(e)}
      />
    </div>
  )
}

export default StoreComment
